// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1H5WM","content":"LoadingAlert_content__3KEAH"};